import { PERMISSION } from '@/constants/permission.constant';

const list = () => import('@/views/faq/List.vue');
const edit = () => import('@/views/faq/Edit.vue');
const create = () => import('@/views/faq/Create.vue');

export const faqRoute = [
  {
    path: '/faqs',
    name: 'faq-list',
    component: list,
    meta: { requiresAuth: false, permissions: [PERMISSION.FAQ_READ] },
  },
  {
    path: '/faqs/create',
    name: 'faq-create',
    component: create,
    meta: { requiresAuth: false, permissions: [PERMISSION.FAQ_CREATE] },
  },

  {
    path: '/faqs/update/:id/edit',
    name: 'faqs-update',
    component: edit,
    meta: { requiresAuth: false, permissions: [PERMISSION.FAQ_UPDATE] },
  },
];
